import * as React from 'react';
import { observer } from 'mobx-react-lite';
import { TFNAnswerSubjectProps, TFNAnswerSubject } from './TFNAnswerSubject';

export interface YNNAnswerSubjectProps extends TFNAnswerSubjectProps {}

export const YNNAnswerSubject = observer((props: YNNAnswerSubjectProps) => {
  return <TFNAnswerSubject {...props} />;
});
